<template>
  <el-tooltip
    :content="$t('common.interactions.buttons.help_and_contact')"
    placement="bottom"
  >
    <el-button
      tag="a"
      :href="supportDocsLink"
      target="_blank"
      rel="noopener noreferrer"
      class="el-button--text-icon"
      text
      size="default"
      :aria-label="$t('common.interactions.buttons.help_and_contact')"
      data-testid="support-docs-link"
    >
      <!-- The glyph fills 13.33 of the 16 unit viewBox, so 17.28px renders the 14.4px icon from the design -->
      <question-filled-icon class="w-[17.28px] h-[17.28px]" />
    </el-button>
  </el-tooltip>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { QuestionFilledIcon } from '@shared/assets/icons'
import { getUnzerSupportDocsLink } from '@shared/constants'

const { locale } = useI18n()

const supportDocsLink = computed(() => getUnzerSupportDocsLink(locale.value))
</script>
